import {hasDevFlag, PermissionsInfo, RequestInfo} from "@khan/shared-core";

import type {Features} from "./types.ts";

const features: Features = {
    get logging(): boolean {
        // We turn off logging when running tests to avoid cluttering up the
        // output too much, unless we want to log fetches, which is useful for
        // debugging graphql queries - this currently means that KA_LOG_FETCHES
        // is akin to enabling console logging of Log.log during tests.
        if (process.env.NODE_ENV === "test" && !process.env.KA_LOG_FETCHES) {
            return false;
        }

        // Logging is enabled when,
        // - we're running on the dev server
        // - the user has dev/admin permissions
        // - logging is force enabled by dev flag
        // - we're likely running embedded in the mobile app
        return (
            RequestInfo.IS_DEV_SERVER ||
            PermissionsInfo.hasAnyPermissions ||
            hasDevFlag("logging") ||
            RequestInfo.isMobileApp
        );
    },
};

export default features;
